import React from 'react';
import { motion } from 'framer-motion';

const accentColors = {
  primary: 'from-[#4F7DF3] to-transparent',
  success: 'from-[#2FBF71] to-transparent',
  error: 'from-[#E5533D] to-transparent',
  warning: 'from-[#F4B740] to-transparent',
};

const Card = ({ children, className = '', hover = false, onClick, accent }) => (
  <motion.div
    whileHover={hover ? { y: -3, transition: { duration: 0.2 } } : {}}
    onClick={onClick}
    className={`
      relative overflow-hidden
      bg-[#121C2E] border border-[#1F2A44] rounded-[10px]
      shadow-[inset_0_1px_0_0_rgba(255,255,255,0.03),0_4px_16px_rgba(0,0,0,0.25)]
      ${hover ? 'cursor-pointer transition-all duration-200 hover:border-[#2A3654] hover:shadow-qa-glow' : ''}
      ${className}
    `}
  >
    {/* Gradient top border accent */}
    {accent ? (
      <div className={`absolute top-0 left-0 right-0 h-[2px] bg-gradient-to-r ${accentColors[accent] || accentColors.primary}`} />
    ) : (
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[rgba(79,125,243,0.3)] to-transparent" />
    )}
    {children}
  </motion.div>
);

export default Card;
